import { Measurement } from '../http/meas-service';

/**
 * Cumulative depth at sensor index i in meters.
 * depths[] stores incremental values in centimeters; sum and negate (downward).
 */
export function toDepth(m: Measurement, i: number): number {
    let sm = 0;
    for (let j = 0; j <= i; j++) sm -= m.depths[j];
    return sm / 100;
}
